import React, { useState,useEffect } from "react";
import withRouter from "../../../components/Common/withRouter";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {
  Card,CardTitle,
  CardBody,
  Col,
  Container,
  Row,
  Table,
  Badge,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Input,
  Button,
  FormFeedback,
} from "reactstrap";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import ReactQuill from "react-quill";
import toast from "react-hot-toast";
import { hasPermission } from "../../../helpers/permission";

const Legal = () => {
  const [editPage, setEditPage] = useState(false);
  const [pageData, setPageData] = useState([]);
  const [legalContentPages, setlegalContentPages] = useState([]);
  const [error, setError] = useState(null);
const [shortContent, setShortContent] = useState("");

  const baseurl = process.env.REACT_APP_BASE_URL;
  const imgurl = process.env.REACT_APP_IMAGE_URL;

    const fetchpagesData = async () => {
            try {
              setError(null);
              const response = await fetch(`${baseurl}/admin/content/pages`);
              if (!response.ok) throw new Error("Network response was not ok");
              const data = await response.json();
              setlegalContentPages(data);
              setShortContent(data?.page_description || "");
            } catch (error) {
              setError(error.message);
            }
          };
        
          useEffect(() => {
            fetchpagesData();
          }, []);


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (pageData && pageData.id) || "",
      pageName: (pageData && pageData?.pagename) || "",
      slug: (pageData && pageData?.slug) || "",
      metaTitle: (pageData && pageData?.meta_title) || "",
      metaDescription: (pageData && pageData?.meta_description) || "",
      metaKeywords: (pageData && pageData?.meta_keywords) || "",
      status: (pageData && pageData?.status) || "Active",
    },
    validationSchema: Yup.object({
      pageName: Yup.string().required("Please enter the page name"),
      slug: Yup.string().required("Please enter slug"),
      status: Yup.string().required("Please select the status"),
      
      metaTitle: Yup.string().required("Meta title is required"),
            metaDescription: Yup.string()
              .required("Meta description is required")
              .max(180, "Max 180 characters allowed"),
            metaKeywords: Yup.string().required("Meta keywords are required"),
    }),
    onSubmit: async (values) => {
          const { id, pageName, status,metaTitle,metaDescription,metaKeywords } = values;
      
          try {
            let response;
              response = await fetch(baseurl+`/admin/content/pages/${id}`, {
                method: 'PUT',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  pagename: pageName,
                 // slug : slug,
                  meta_title: metaTitle,
                  meta_description : metaDescription,
                  meta_keywords : metaKeywords,
                  page_description : shortContent,
                  status : status,
                }),
              });
              if (!response.ok) {
                throw new Error("Error updating user");
              }
               setEditPage(false);
              toast.success('Page Details updated successfully!', 'success');
                fetchpagesData();
              
              
          } catch (error) {
            console.error(error);
            // Handle any errors, show an error message if needed
          }
        },
  });

  const handleEditClick = (data) => {
    setPageData({
      ...data,
      status: data.status,
    });
    setShortContent(data.page_description);
    setEditPage(true);
  };
const handleShortContentChange = (newContent) => {
    setShortContent(newContent);
  };
  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      [{ align: [] }],
      [{ color: [] }],
      ["code-block"],
      ["clean"],
    ],
    clipboard: {
      matchVisual: false,
    },
  };

  const quillFormats = [
    "header",
    "bold",
    "italic",
    "video",
    "font",
    "size",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "align",
    "color",
    "code-block",
  ];

  document.title = "Legal Page Section | Vekart";

  return (
    <>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Legal" breadcrumbItem="Legal Pages" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="table-responsive">
                    <Table className="table mb-0">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Page Name</th>
                          <th>Slug</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {legalContentPages?.map((data, index) => {
                          return (
                            <>
                              <tr key={index}>
                                <th scope="row">{data?.id}</th>
                                <td className="fw-bold">
                                  {data?.pagename}
                                </td>
                                <td className="text-primary">
                                  {data?.slug}
                                </td>
                                <td>
                                  <Badge
                                    color={
                                      data?.status === "Active"
                                        ? "success"
                                        : "danger"
                                    }
                                  >
                                    {data?.status.charAt(0).toUpperCase() +
                                      data?.status.slice(1)}
                                  </Badge>
                                </td>
                                <td>
                                  <div className="d-flex gap-3">
                                    {hasPermission("contents.blogs.view") && (
                                    <Link
                                      to="#"
                                      className="text-success"
                                      onClick={() => handleEditClick(data)}
                                    >
                                      <i
                                        className="mdi mdi-pencil font-size-18"
                                        id="edittooltip"
                                      />
                                      <UncontrolledTooltip
                                        placement="top"
                                        target="edittooltip"
                                      >
                                        Edit
                                      </UncontrolledTooltip>
                                    </Link>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            </>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Modal for Edit Legal Pages*/}
          <Modal
            isOpen={editPage}
            toggle={handleEditClick}
            backdrop="static"
            keyboard={false}
            size="lg"
          >
            <ModalHeader toggle={() => setEditPage(false)} tag="h4">
              Edit Page
            </ModalHeader>
            <ModalBody>
              <form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col className="col-md-4 col-12">
                    <div className="mb-3">
                      <Label className="form-label">Enter Page Name</Label>
                      <Input
                        name="pageName"
                        type="text"
                        placeholder="Enter page name"
                        readOnly
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.pageName || ""}
                        invalid={
                          formik.touched.pageName && formik.errors.pageName
                            ? true
                            : false
                        }
                      />
                      {formik.touched.pageName && formik.errors.pageName ? (
                        <FormFeedback type="invalid">
                          {formik.errors.pageName}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col className="col-md-4 col-12">
                    <div className="mb-3">
                      <Label className="form-label">Enter Slug</Label>
                      <Input
                        name="slug"
                        type="text"
                        placeholder="Enter slug"
                        readOnly
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.slug || ""}
                        invalid={
                          formik.touched.slug && formik.errors.slug
                            ? true
                            : false
                        }
                      />
                      {formik.touched.slug && formik.errors.slug ? (
                        <FormFeedback type="invalid">
                          {formik.errors.slug}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col className="col-md-4 col-12">
                    <div className="mb-3">
                      <Label className="form-label">Status</Label>
                      <Input
                        name="status"
                        type="select"
                        className="form-select"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.status || ""}
                      >
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </Input>
                      {formik.touched.status && formik.errors.status ? (
                        <FormFeedback type="invalid">
                          {formik.errors.status}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col className="col-12">
                    <div className="mb-5">
                      <Label className="form-label">Page Discription</Label>
                      <ReactQuill
                        value={shortContent}
                        theme="snow"
                         onChange={handleShortContentChange}
                        modules={quillModules}
                        formats={quillFormats}
                        style={{ height: "300px" }}
                        placeholder="Enter your content...."
                        className=""
                      />
                    </div>
                  </Col>
                </Row>
                {/* META CARD */}
         
              
              <Row>
                <Col sm={12} className="mt-3 mb-3"><h5>Meta Data</h5></Col>
                <Col sm={6}>
                  <div className="mb-3">
                    <Label className="form-label">Meta Title</Label>
                    <Input
                      name="metaTitle"
                      type="text"
                      placeholder="Meta Title"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.metaTitle}
                      invalid={
                        formik.touched.metaTitle &&
                        Boolean(formik.errors.metaTitle)
                      }
                    />
                    <FormFeedback>{formik.errors.metaTitle}</FormFeedback>
                  </div>

                  <div className="mb-3">
                    <Label className="form-label">Meta Keywords</Label>
                    <Input
                      name="metaKeywords"
                      type="text"
                      placeholder="Keyword1, Keyword2"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.metaKeywords}
                      invalid={
                        formik.touched.metaKeywords &&
                        Boolean(formik.errors.metaKeywords)
                      }
                    />
                    <FormFeedback>{formik.errors.metaKeywords}</FormFeedback>
                  </div>
                </Col>

                <Col sm={6}>
                  <Label className="form-label">Meta Description</Label>
                  <textarea
                    name="metaDescription"
                    className="form-control"
                    rows="5"
                    maxLength="180"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.metaDescription}
                  ></textarea>
                  <small>
                    {formik.values.metaDescription.length}/180 characters
                  </small>
                  <div className="text-danger">
                    {formik.errors.metaDescription}
                  </div>
                </Col>
                
              </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      <Button type="submit" color="success">
                        Update
                      </Button>
                    </div>
                  </Col>
                </Row>
              </form>
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </>
  );
};

export default withRouter(Legal);
